import React from 'lib/react';
import { useSelector, useDispatch } from 'lib/redux';
import {
  EVGrid, EVInputLabel, EVCheckbox,
} from 'lib/components';
import { UPDATE_TEXT_ALERT_CONDITIONS } from 'constants/ActionTypes';
import { useTranslation } from 'lib/translation';
import Typography from 'commonComponents/typography';
import TextAlertSettingsStyles from '../TextAlertSettingsStyles';
import { getTextAlertValues } from '../TextAlertSettings.utils';

function TextAlertMessage() {
  const dispatch = useDispatch();
  const classes = TextAlertSettingsStyles();
  const { t } = useTranslation();
  const {
    textAlerts, updatedTextAlertPreferences, textAlertPreferences,
  } = useSelector(({ textAlertSettings }) => textAlertSettings);
  const alerts = getTextAlertValues(updatedTextAlertPreferences, textAlertPreferences, 'alerts');

  const handleChange = (event) => {
    const { target: { id, checked } } = event;
    dispatch({
      type: UPDATE_TEXT_ALERT_CONDITIONS, alertId: Number(id), checked,
    });
  };

  return (
    <EVGrid className={classes.textAlertMessageContainer}>
      <Typography fontColor="charcoal-800">
        {t('text_alert_settings__send_me_alerts_when')}
      </Typography>
      <EVGrid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {textAlerts.map((alert) => (
          <EVGrid container alignItems="center" key={alert.name} className={classes.checkChangesContainer}>
            <EVCheckbox
              data-testid={`text-alert-checkbox-${alert.id}`}
              id={String(alert.id)}
              checked={alerts?.find((element) => element.alertId === alert.id)?.active}
              name={alert.name}
              color="primary"
              className={classes.textAlertCheckbox}
              onChange={handleChange}
            />
            <EVInputLabel htmlFor={alert.id} className={classes.textAlertCheckboxLabel}>
              {alert.description}
            </EVInputLabel>
          </EVGrid>
        ))}
      </EVGrid>
    </EVGrid>
  );
}

export default TextAlertMessage;
